import { Button } from '@/components/ui/button'

export default function AdminLogin() {
  const handleLogin = () => {
    // TODO: Redirect to GitLab OAuth
    window.location.href = '/api/auth/gitlab'
  }

  return (
    <div className="min-h-screen flex">
      {/* Left Panel - Login Form */}
      <div className="w-full lg:w-1/2 bg-white flex flex-col justify-center px-8 lg:px-16 py-12">
        <div className="max-w-md mx-auto lg:mx-0 w-full">
          <h1 className="text-3xl font-bold text-bronze mb-2">
            Connexion Opérateur
          </h1>
          <p className="text-muted-foreground mb-8">
            Connectez-vous avec votre compte GitLab pour accéder au tableau de bord d'administration.
          </p>

          <Button
            className="w-full bg-gold hover:bg-gold/90 text-white font-semibold rounded-full py-6"
            onClick={handleLogin}
          >
            Se connecter avec GitLab
          </Button>

          <p className="mt-6 text-sm text-muted-foreground text-center">
            Seuls les opérateurs autorisés peuvent accéder à cette section.
          </p>
        </div>
      </div>

      {/* Right Panel - Decorative */}
      <div className="hidden lg:flex lg:w-1/2 bg-pattern-curves items-center justify-center p-12">
        <div className="relative z-10 text-white max-w-md">
          <h2 className="text-3xl font-bold mb-6">
            Espace Opérateur
          </h2>
          <p className="text-white/80 mb-8">
            Gérez les demandes d'onboarding et supervisez le provisionnement des environnements clients.
          </p>

          <div className="space-y-6">
            <div className="bg-white/10 backdrop-blur rounded-lg p-4">
              <h3 className="font-semibold mb-2">Gestion des Demandes</h3>
              <p className="text-white/70 text-sm">
                Examinez et approuvez les nouvelles demandes d'intégration.
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur rounded-lg p-4">
              <h3 className="font-semibold mb-2">Provisionnement</h3>
              <p className="text-white/70 text-sm">
                Déclenchez et suivez le provisionnement des environnements.
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur rounded-lg p-4">
              <h3 className="font-semibold mb-2">Supervision</h3>
              <p className="text-white/70 text-sm">
                Surveillez l'état des pipelines et des environnements.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
